import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ea0a09b0&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a09b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0a09b0')) {
      api.createRecord('ea0a09b0', component.options)
    } else {
      api.reload('ea0a09b0', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ea0a09b0&scoped=true&", function () {
      api.rerender('ea0a09b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8RWzUnBTxZfWp/JS/comp/Accordion.vue"
export default component.exports